import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Partner } from '@marageti/z4-sdk/lib/travel';
import { useApiClient, useFetch } from '@marageti/z4-lib';
import { useSnackbar } from 'notistack';
import NonCompeteView from './non-compete-view';

const NonCompeteContainer = () => {
  const { enqueueSnackbar } = useSnackbar();
  const apiClient = useApiClient();
  const { partnerId } = useParams<{ partnerId: string }>();

  const [noCompeteToDelete, setNoCompeteToDelete] = useState<string | undefined>();

  const {
    data: partner, error, isLoading, mutate,
  } = useFetch<Partner>(apiClient.partnersClient.getPartner, [partnerId], true);

  const onConfirmDelete = async () => {
    try {
      await apiClient.partnersClient.deletePartnerNoCompete(partnerId!, noCompeteToDelete!);
      mutate();
      enqueueSnackbar('Non-compete partner deleted.', { variant: 'success' });
    } catch (err) {
      enqueueSnackbar('Non-compete partner delete failed.', { variant: 'default' });
    } finally {
      setNoCompeteToDelete(undefined);
    }
  };

  const onDeleteClick = (noCompetePartnerId: string) => {
    setNoCompeteToDelete(noCompetePartnerId);
  };

  const onCancelDelete = () => (setNoCompeteToDelete(undefined));

  return (
    <NonCompeteView
      noCompetesError={error}
      noCompetesLoading={isLoading}
      noCompeteToDelete={noCompeteToDelete}
      nonCompetes={partner?.noCompete}
      onCancelDelete={onCancelDelete}
      onConfirmDelete={onConfirmDelete}
      onRemoveNoCompete={onDeleteClick}
    />
  );
};

export default NonCompeteContainer;
